export default {
  name: "EventCategoryEdit",
  props: ["editedCategory"]
};
